import { Typography } from '@mui/material';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';
import { infoContentPeerGroups } from 'pages/Benchmarking/common/InfoDrawerPeerGroupContent';
import { FormattedMessage } from 'react-intl';
import { InfoAlert } from 'components/alert/InfoAlert';
import { OrderBasedKpiNote } from 'components/InfoDrawer/InfoDrawerKpiNote';
import { useModelService } from 'services/model/model.service';

export function PerformanceDashboardInfoContent() {
  const { getMeasure } = useModelService();
  const retQtyRateExpMeasure = getMeasure('retQtyRateExpOD');

  return (
    <div>
      <InfoAlert messageId="benchmarking.info.alert" />

      <Typography variant="body1" sx={{ fontWeight: 400, mb: 3 }}>
        <FormattedMessage id="info.content.kpis" defaultMessage="Key Performance Indicators (KPIs)" />
      </Typography>
      <OrderBasedKpiNote />

      <InfoContentItem
        titleId="benchmarking.titles.additional.yoy_performance"
        descriptionId="benchmarking.titles.additional.yoy_performance.description"
      />

      <InfoContentItem
        titleId="benchmarking.titles.additional.pop_performance"
        descriptionId="benchmarking.titles.additional.pop_performance.description"
      />

      <InfoContentItem
        titleId="benchmarking.titles.additional.timeframe.selection"
        descriptionId="benchmarking.titles.additional.timeframe.selection.description"
      />

      <InfoContentItem
        titleId="model.metric.retQtyRate.name"
        descriptionId="benchmarking.performance.kpi.result.returns.description"
        highlighted
        measure={retQtyRateExpMeasure}
      />

      <InfoContentItem
        titleId="benchmarking.performance_tab.info.content.why_are_the_return_rates_important.title"
        descriptionId="benchmarking.performance_tab.info.content.why_are_the_return_rates_important.description"
      />

      <InfoContentItem
        titleId="benchmarking.performance.section.cancellations_over_time"
        descriptionId="benchmarking.titles.cancellations.description"
      />

      <InfoContentItem
        titleId="benchmarking.performance_tab.info.content.why_are_the_cancellation_rates_important.title"
        descriptionId="benchmarking.performance_tab.info.content.why_are_the_cancellation_rates_important.performance.description"
      />

      <hr className="my-4 border-snow-200" />
      <Typography variant="body1" sx={{ fontWeight: 400, mb: 3 }}>
        <FormattedMessage id="benchmarking.performance_tab.peer_groups" />
      </Typography>

      {infoContentPeerGroups.map(peerGroup => (
        <InfoContentItem key={peerGroup.title} titleId={peerGroup.title} descriptionId={peerGroup.description} />
      ))}

      <hr className="my-4 border-snow-200" />

      <Typography variant="body1" sx={{ fontWeight: 400, mb: 3 }}>
        <FormattedMessage id="info.content.abbreviations" />
      </Typography>

      <InfoContentItem
        titleId="help.glossary.percentage_points.title"
        descriptionId="help.glossary.percentage_points.description"
      />
    </div>
  );
}
